<template>
    <ReviewsRecommendationsIndicator :appraisals="appraisals" :recommendations="recommendations">
        <template #ask-for-recommendations>
            <ClientOnly>
                <VJoyWrapper no-margin column-gap="1" wrap="nowrap">
                    <VJoyIcon name="thumbup" color="neutral-50" size="xsmall" />
                    <VJoyLink
                        class="reviews-recommendations-indicator__link"
                        data-testid="profile-header-ask-for-recommendations-cta"
                        @click="askForRecommendations"
                    >
                        {{ $t('profile.section.header.recommendations.ask.label') }}
                    </VJoyLink>
                </VJoyWrapper>
                <template #fallback>
                    <VJoyFormFieldSkeleton size="xxsmall" width="217px" />
                </template>
            </ClientOnly>
        </template>
    </ReviewsRecommendationsIndicator>
</template>

<script setup lang="ts">
    import {VJoyIcon, VJoyWrapper, VJoyLink, VJoyFormFieldSkeleton} from '@maltjoy/core-vue';
    import {eventBus} from '~/config/events';
    import {RecommendationRequestStartedEntryPoint} from '~/config/TrackingEvents';
    import type {Appraisals} from '~/types/domain/Appraisals';
    import type {Recommendations} from '~/types/domain/Recommendations';
    import ReviewsRecommendationsIndicator from './ReviewsRecommendationsIndicator.vue';

    defineProps<{
        appraisals?: Appraisals;
        recommendations?: Recommendations;
    }>();

    function askForRecommendations() {
        eventBus.emit('recommendations:edit-mode', {entryPoint: RecommendationRequestStartedEntryPoint.HEADER_CTA});
    }
</script>
<style scoped lang="scss">
    .reviews-recommendations-indicator__link {
        font-weight: var(--joy-font-weight-normal);
        white-space: nowrap;
    }
</style>
